import { getDefaultSuboption } from '../../helpers/getDefaultSubOption';
import { uniqBy, flatten } from 'lodash';
import * as queryString from 'query-string';
import * as React from 'react';
import { MutationFunc } from 'react-apollo';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ApolloClientFactory } from '../../domain/apolloClientFactory';
import { buildIValueLabelPairFromValue } from '../../helpers/attributes/buildIValueLabelPairFromValue';
import { buildPriceLabelFromPriceIndex } from '../../helpers/buildPriceLabelFromPriceIndex';
import { paginateElements } from '../../helpers/paginateElements';
import { filterProducts, filterProductsByPrice, filterVariants, getAllSizesForVariant } from '../../helpers/products';
import { IValueLabelPair } from '../../modules/Form/Select';
import { Container, Pagination, ProductBox, Title } from '../../modules/modules';
import AuthService from '../../services/AuthService';
import FlashStore from '../../services/FlashStore';
import FilterableAttributes from '../Query/Attributes/FilterableAttributes';
import Favorites from '../Query/Products/Favorites';
import FullVariants, { GetFullVariantsQuery } from '../Query/Products/FullVariants';
import { ISelectedSubOptions } from './interfaces/ISelectSubOption';
import { ISelectedFilters } from './interfaces/ISelectedFilters';
import CountryService from '../../services/CountryService';
import Helmet from 'react-helmet';
import ReloadPage from '../ReloadPage';
import { canUseWindow, canUseDOM } from '../../utils';
import GoogleTagManagerService from '../../services/GoogleTagManagerService';

interface IProductListProps extends RouteComponentProps<{ language: string }> {
  category: GQL.ICategory | undefined;
  categoryByTag: any | undefined;
  toggleFavorite?: MutationFunc;
  usedAttributesMap: any;
  allProducts: GQL.IProduct[];
  productTags: GQL.IProductTag[];
  productsCategories: any;
  products: any;
  search?: string | string[] | undefined;
  setCurrentProductAvailabityWatchdogForm?: (
    product?: GQL.IProduct,
    variant?: GQL.IProductVariant,
  ) => void;
  reloadPage: boolean;
}

// tslint:disable-next-line:no-empty-interface
interface IProductListState {
  loadingAdditionalVariants: boolean;
  infiniteScrollRound: number;
  nextButton: any | null;
  page: number;
  limit: number;
  dropdownFilter: boolean;
  additionalVariants: IAdditionalProducts;
  preloadedImages?: any[] | undefined;
}

class ProductList extends React.Component<IProductListProps, IProductListState> {
  private uniqueVariants: Array<GQL.IProductVariant>;

  constructor(props: IProductListProps) {
    super(props);

    this.state = {
      infiniteScrollRound: 0,
      loadingAdditionalVariants: false,
      nextButton: null,
      page: 1,
      limit: 24,
      dropdownFilter: false,
      additionalVariants: { offset: 1, additionalVariants: [] },
    };

    this.toggleFavorite = this.toggleFavorite.bind(this);
    this.onPageChanged = this.onPageChanged.bind(this);
    this.refNextButton = this.refNextButton.bind(this);
    this.scrollListener = this.scrollListener.bind(this);
  }

  private scrollListener(event: any) {
    if (this.state.nextButton && this.state.loadingAdditionalVariants === false) {
      const root = document.getElementById('root');
      const triggerOnPosition = root && root.scrollTop || window.scrollY + window.outerHeight + 500;
      const buttonPosition = this.state.nextButton.offsetTop;

      if (
        triggerOnPosition > buttonPosition
          && !this.state.loadingAdditionalVariants
          && this.state.infiniteScrollRound < 5
      ) {
        this.setState({
          loadingAdditionalVariants: true,
        }, () => { return; }
          // this.state.nextButton.click()
        );
      }
    }
  }

  public componentDidMount() {
    // Infinite scroll the worst way it is possible
    if (window) {
      if (window.location && window.location.search) {
        const parsed = queryString.parse(window.location.search) as any;
        if (parsed.page) {
          this.setState({
            page: parseInt(parsed.page || this.state.page),
          });
        }
      }

      if (window.addEventListener && window.document && window.document.body) {
        window.addEventListener('scroll', this.scrollListener);
      }
    }

    // Preload obrázků, aby nedocházelo k jejich znovunačtení při manipulaci s DOMem Reactem
    if (canUseWindow() && ('querySelectorAll' in document)) {
      const preloadImages: HTMLImageElement[] = [];
      const ssrImages = document.querySelectorAll('.productList .row.no-gutters .productBox__image img') as NodeListOf<HTMLImageElement>;
      ssrImages.forEach((img) => {
        const url = img.src;
        if (url) {
          const image = new Image();
          image.src = url;
          preloadImages.push(image);
        }
      });
      this.setState({preloadedImages: preloadImages});
    }
  }

  public componentWillUnmount() {
    if (window) {
      window.removeEventListener('scroll', this.scrollListener);
    }

    // Uvolnění obrázků
    this.setState({ preloadedImages: undefined });
  }

  public renderSSRProducts(ssrContent: string | null) {
    if (!ssrContent) {
      return null;
    }

    return (
      <div className="products">
        <div className="productList">
          <div className="row no-gutters" dangerouslySetInnerHTML={{ __html: ssrContent }} />
        </div>
      </div>
    );
  }

  public render() {
    const { language, currency } = CountryService.GetInstance();
    const { usedAttributesMap, allProducts, products, productTags, category, reloadPage, search, location: { search: s, pathname} } = this.props;

    if (reloadPage) {
      return <ReloadPage />;
    }

    return (
      <>
        <Helmet>
          <title>{`${(category && category.metaTitle && category.metaTitle[language])
              || (category &&  category.name && category.name[language])
              || 'Search'} | ${process.env.REACT_APP_PROJECT_NAME}`}</title>
          {category && category.metaDescription && <meta name="description" content={`${category.metaDescription[language]}`} />}
          <meta property="og:title" content={`${(category && category.metaTitle && category.metaTitle[language])
              || (category && category.name && category.name[language])
              || 'Search'} | ${process.env.REACT_APP_PROJECT_NAME}`} />
          {category && category.metaDescription && <meta property="og:description" content={`${(category && category.metaDescription[language])}`} />}
          {!category && <meta name="robots" content="noindex" /> || ''}
        </Helmet>
        <Favorites>
          {({ favorites }: any) => {

            if (/*Object.keys(usedAttributesMap).length === 0 && */!products.loading && products.minimalProducts && products.minimalProducts.length === 0) {

              if ('string' === typeof search) {
                GoogleTagManagerService.productsInCategory([], { searchQuery: search });
              }
              return (
                <div className="section section--productList" style={{ textAlign: 'center', height: '400px' }}>
                  <Container>
                    <div className="activeFilters" />
                    <Title>
                      {canUseWindow() && window.location && window.location.search 
                        ? 'No products found' 
                        : 'No products in this category'}
                    </Title>
                    <div className="text-error mt-2">:(</div>
                  </Container>
                </div>
              );
            }

            return (
              <FilterableAttributes ids={Object.keys(usedAttributesMap)}>
                {({ attributes }: any) => {
                  // Načte případný existující obsah vygenerovaný SSR
                  let ssrContent: string | null = null;
                  if (canUseDOM() && ('querySelector' in document)) {
                    const ssrProductList = document.querySelector('.productList .row.no-gutters');
                    if (ssrProductList) {
                      ssrContent = ssrProductList.innerHTML;
                    }
                  }

                  if ((attributes.loading || attributes.attributes == undefined)) {
                    return this.renderSSRProducts(ssrContent);
                  }

                  const filters = this.getDynamicFilters(attributes.attributes, language);
                  const uniqueVariants = this.uniqueVariants = filterProducts(
                    allProducts,
                    filters,
                    this.getPriceFilters(),
                    filterProductsByPrice,
                    filterVariants,
                    favorites.favorites
                  );

                  const paginatedVariants = paginateElements(
                    uniqueVariants,
                    this.getPage(),
                    this.state.limit
                  ).map(v => v.id);

                  const searchPriorities = uniqueVariants.reduce((acc: {[id: string]: number}, variant: GQL.IProductVariant) => {
                    acc[variant.id] = 'number' === typeof (variant as any).searchPriority ? (variant as any).searchPriority : Infinity;
                    return acc;
                  }, {});

                  // indicates empty list for render
                  let emptyList = false;
                  if (Array.isArray(paginatedVariants) && paginatedVariants.length === 0) {
                    // hack that should prevent displaying empty products when products exists
                    // wrong data-flow design cases displaying it during development
                    // setTimeout(this.props.onLoaded, 1000);
                    emptyList = true;

                    return this.renderSSRProducts(ssrContent);
                  }

                  const selectedSubOptions = this.getSelectedSubOptions(attributes.attributes, language);
                  const usedAttributes = Object.keys(usedAttributesMap).map(aId =>
                    attributes.attributes.find((a: GQL.IAttribute) => a.id == aId)
                  );

                  return (
                    <div className="products">
                      <div className="productList">
                        {emptyList &&
                          <p className="boundaries">
                            No products found
                          </p>}
                        {Array.isArray(paginatedVariants) && paginatedVariants.length > 0 && currency
                          && <FullVariants ids={paginatedVariants} categoryId={this.props.category && this.props.category.id} currencyId={currency.id}>
                            {({ fullVariants }: any) => {

                              if ((this.props.products.loading) || (fullVariants.loading && !fullVariants.variants)) {
                                if (ssrContent) {
                                  return <div className="row no-gutters" dangerouslySetInnerHTML={{ __html: ssrContent }} />;
                                } else {
                                  return null;
                                }
                              }

                              // Filter change: Blocks loading
                              if (fullVariants.loading) {
                                if (ssrContent) {
                                  return <div className="row no-gutters" dangerouslySetInnerHTML={{ __html: ssrContent }} />;
                                } else {
                                  return null;
                                }
                              }

                              const searchQuery = Array.isArray(search) ? search.join(' : ') : search;
                              GoogleTagManagerService.productsInCategory(fullVariants.variants, { searchQuery });

                              if (fullVariants.variants && fullVariants.variants.length == 0) {
                                return (
                                  <p className="boundaries">
                                    No products found
                                  </p>
                                );
                              }

                              return (
                                <React.Fragment>
                                  <div className="row no-gutters">

                                    {(fullVariants.variants as Array<GQL.IProductVariant>)
                                      .concat(
                                        this.state.additionalVariants
                                          .additionalVariants
                                      )
                                      .sort((a, b) => category ? 0 : searchPriorities[a.id] - searchPriorities[b.id])
                                      .map(variant => (
                                        <div key={variant.id} className="productList__item col-12 col-xs-6 col-sm-4 col-lg-3">
                                          <ProductBox
                                            language={language}
                                            isFavorite={favorites.favorites.some(
                                              (v: GQL.IProductVariant) =>
                                                v.id == variant.id
                                            )}
                                            category={this.props.category}
                                            sizes={getAllSizesForVariant(
                                              variant.product.id,
                                              variant,
                                              allProducts,
                                              attributes.attributes.filter(({ tags }: any) => tags.includes('size')),
                                              language,
                                              selectedSubOptions
                                            )}
                                            tags={productTags}
                                            onToggleFavorite={async vId => {
                                              await this.toggleFavorite(vId);
                                              await favorites.refetch();
                                            }}
                                            variant={variant}
                                            boxType="buy"
                                            setCurrentProductAvailabityWatchdogForm={this.props.setCurrentProductAvailabityWatchdogForm}
                                          />
                                        </div>
                                      ))}
                                  </div>
                                  <div className="mt-2">
                                    <Pagination
                                      // generation of urls
                                      pathname={pathname}
                                      search={s}

                                      refNextButton={this.refNextButton}
                                      currentPage={this.getPage()}
                                      limit={this.state.limit}
                                      totalRecords={uniqueVariants.length}
                                      onPageChanged={(page: number, reset: boolean) => {
                                        return this.onPageChanged(page, reset, uniqueVariants);
                                      }}
                                      doNotGenerateSSRLinks={!category}
                                    />
                                  </div>
                                  {category?.longDescription && category.longDescription[language]
                                  && <div dangerouslySetInnerHTML={{__html: category.longDescription[language] }}/>
                                  || ''}
                                </React.Fragment>
                              );
                            }}
                          </FullVariants>}
                      </div>
                    </div>
                  );
                }}
              </FilterableAttributes>
            );
          }}
        </Favorites>
      </>
    );
  }

  private async toggleFavorite(variantId: string) {
    const language = CountryService.GetInstance().language;

    if (this.props.toggleFavorite) {
      try {
        const result = await this.props.toggleFavorite({
          variables: {
            variantId
          }
        });
        if (result.data.toggleFavorite) {
          FlashStore.GetInstance().showMessage(
            'Úspěšně přidáno do oblíbených',
            'success',
            4000,
            `/${language}/favorite`
          );
        } else {
          if (AuthService.GetInstance().loggedIn) {
            FlashStore.GetInstance().showMessage(
              'Odebráno z oblíbených',
              'success',
              4000,
              `/${language}/favorite`
            );
          } else {
            FlashStore.GetInstance().showMessage('Nejdříve se přihlaste nebo zaregistrujte', 'failure');
          }
        }
      } catch (e) {
        FlashStore.GetInstance().showMessage('Nejdříve se přihlaste nebo zaregistrujte', 'failure');
      }
    }
  }

  private async loadAdditionalVariants(uniqueVariants: Array<GQL.IProductVariant>, page: number) {
    const client = ApolloClientFactory.GetClient();

    const variantsToFetch = paginateElements(
      uniqueVariants,
      page,
      this.state.limit
    ).map(v => v.id);

    const data = await client.query({
      query: GetFullVariantsQuery,
      variables: { categoryId: this.props.category && this.props.category.id, ids: variantsToFetch }
    });

    if (data.data && (data.data as any).variants) {
      this.setState({
        additionalVariants: {
          offset: 0,
          additionalVariants: this.state.additionalVariants.additionalVariants.concat(
            data.data && (data.data as any).variants
          )
        }
      });

    }
  }

  private resetAdditionalVariants() {
    this.setState({ additionalVariants: { offset: 1, additionalVariants: [] } });
  }

  private toggleDropdown(open?: boolean) {
    if (open === undefined) {
      open = !this.state.dropdownFilter;
    }

    this.setState({ dropdownFilter: open });
  }

  private onChangePriceFilter(vals: Array<IValueLabelPair>) {
    this.resetAdditionalVariants();
    const parsed = window && window.location && queryString.parse(window.location.search) || {};
    parsed.page = '1';

    const priceFilters = new Array<string>();
    for (const val of vals) {
      priceFilters.push(val.value);
    }

    parsed.price = priceFilters;

    // To query without reload
    this.changeQueryString(parsed, false);
  }

  private onChangeFilter(key: string, val: Array<IValueLabelPair>, attributes: Array<GQL.IAttribute>, language: string) {
    this.resetAdditionalVariants();

    const currentFilters = this.getDynamicFilters(attributes, language);
    const allAttributeValues = flatten(attributes.map(a => a.values || []));

    const newQueryString = {} as any;

    currentFilters[key] = val; // key is attributeId

    for (const attributeId of Object.keys(currentFilters)) {
      const attribute = attributes.find(a => a.id == attributeId);
      if (attribute == undefined || attribute.slug == undefined || attribute.slug[language] == undefined) {
        continue;
      }

      newQueryString[attribute.slug[language]] = [];

      const valueIds = currentFilters[attributeId].map((v: any) => v.value);
      for (const valueId of valueIds) {
        const value = allAttributeValues.find(v => v.id == valueId);
        if (value == undefined || value.slug == undefined || value.slug[language] == undefined) {
          continue;
        }

        newQueryString[attribute.slug[language]].push(value.slug[language]);
      }
    }

    const currentQueryString = window && window.location && queryString.parse(window.location.search) || {};
    if (currentQueryString && currentQueryString.page) {
      currentQueryString.page = '1';
    }

    // To query without reload
    this.changeQueryString({ ...currentQueryString, ...newQueryString }, false);
  }

  private onChangeSubOption(attributeId: string, option: string, attributes: Array<GQL.IAttribute>, language: string) {
    const parsed = window && window.location && queryString.parse(window.location.search) || {};
    const attribute = attributes.find(a => a.id == attributeId);
    if (attribute == undefined || attribute.slug == undefined || attribute.slug[language] == undefined) {
      return;
    }

    parsed[`${attribute.slug[language]}~sub`] = option.toLowerCase();

    // Without reload to query
    this.changeQueryString(parsed, false);
  }

  private getSelectedSubOptions(attributes: Array<GQL.IAttribute>, language: string) {
    const options: ISelectedSubOptions = {};

    const parsed = window && window.location && queryString.parse(window.location.search);
    if (parsed) {
      for (const attributeSlug of Object.keys(parsed)) {
        if (attributeSlug && attributeSlug.indexOf('~') > 0) {
          const splited = attributeSlug.split('~'); // [slug]-sub
          if (splited[1] === 'sub') {
            const attribute = attributes.find(a => a.slug && a.slug[language] == splited[0]);
            if (attribute == undefined) {
              continue;
            }

            options[attribute.id] = ('' + parsed[attributeSlug]).toUpperCase();
          }
        }
      }
    }

    return options;
  }

  private changeQueryString(query: object, withReload: boolean) {
    // remove page from query, if page == 1
    if ((query as any).page && (2 > (query as any).page)) {
      delete((query as any).page);
    }
    const qs = queryString.stringify(query);

    if (withReload) {
      this.props.history.push({
        pathname: this.props.location.pathname,
        search: qs
      });
    } else {
      history.pushState(null, '', this.props.location.pathname + '?' + qs);
      this.forceUpdate();
    }
  }

  private getDynamicFilters(attributes: Array<GQL.IAttribute>, language: string) {
    const parsed = window && window.location && queryString.parse(window.location.search) || {};

    const otherFilters = { ...parsed, page: undefined, limit: undefined, price: undefined };

    const selectedFilters: ISelectedFilters = {};

    for (const attributeSlug of Object.keys(otherFilters)) {
      const attribute = attributes.find(a => a.slug && a.slug[language] == attributeSlug);
      if (attribute == undefined) {
        continue;
      }

      const filters = new Array<IValueLabelPair>();

      if (Array.isArray(otherFilters[attributeSlug])) {
        for (const valueSlug of otherFilters[attributeSlug]) {
          const value = (attribute.values || []).find(v => v.slug && v.slug[language] == valueSlug);
          if (value == undefined) {
            continue;
          }
          const subOption = (
            this.getSelectedSubOptions(attributes, language)[attribute.id] ||
            getDefaultSuboption(attribute) ||
            ''
          ).toUpperCase();

          filters.push(buildIValueLabelPairFromValue(value, language, subOption.toUpperCase(), attribute));
        }
      } else {
        const value = (attribute.values || []).find(v => v.slug && v.slug[language] == otherFilters[attributeSlug]);
        if (value == undefined) {
          continue;
        }

        const subOption = (
          this.getSelectedSubOptions(attributes, language)[attribute.id] ||
          getDefaultSuboption(attribute) ||
          ''
        ).toUpperCase();

        filters.push(buildIValueLabelPairFromValue(value, language, subOption.toUpperCase(), attribute));
      }

      selectedFilters[attribute.id] = filters;
    }

    return selectedFilters;
  }

  private getPage() {
    const { location: { search } } = this.props;
    const params = new URLSearchParams(search);
    const tempPage = params.get('page');
    const page = tempPage ? parseInt(tempPage) : 1;
    return page;
  }

  private getPriceFilters() {
    const pairs = new Array<IValueLabelPair>();

    const parsed = window && window.location && queryString.parse(window.location.search) || {};
    const price = parsed && parsed.price;

    if (Array.isArray(price)) {
      for (const priceIndex of price) {
        pairs.push({ label: buildPriceLabelFromPriceIndex(priceIndex), value: priceIndex });
      }
    } else if (price != undefined) {
      pairs.push({ value: price, label: buildPriceLabelFromPriceIndex(price) });
    }

    return pairs;
  }

  private getAttributeFilters(filters: any, attributes: GQL.IAttribute[], language: string) {
    const filteredValues = [] as any[];
    Object.keys(filters).map(key => {
      const tempFilteredValues = filters[key];
      filteredValues.push(...tempFilteredValues);
    });

    return uniqBy(filteredValues, 'label').map((filteredValue: any) => {
      const keys = Object.keys(filters).filter(k => filters[k].some((v: any) => v.label == filteredValue.label)) || '';
      return (
        <button
          onClick={() => {
            for (const key of keys) {
              this.onChangeFilter(
                key,
                filters[key].filter((f2: any) => f2.label != filteredValue.label),
                attributes,
                language
              );
            }
          }}
          key={filteredValue.value}
          className="activeFilters__item"
        >
          {filteredValue.label}
        </button>
      );
    });
  }

  private refNextButton(nextButton: any) {
    this.setState({
      nextButton
    });
  }

  private onPageChanged(page: number, reset: boolean, uniqueVariants: any) {
    if (reset) {
      if (window && window.location) {
        const parsed = window.location.search
          ? queryString.parse(window.location.search) as any
          : {} as any;

        window.scrollTo(0, 95);
        this.changeQueryString({ ...parsed, page }, reset);

      }
      return;
    }

    if (!reset) {
      this.setState({
        page,
      }, () => {
        this.loadAdditionalVariants(uniqueVariants, page);
      });
    }
  }
}

export default withRouter(ProductList);



// WEBPACK FOOTER //
// ./src/components/ProductList/ProductList.tsx